import { render, staticRenderFns } from "./AccordionPanel.vue?vue&type=template&id=48aa160c&scoped=true&"
import script from "./AccordionPanel.vue?vue&type=script&lang=js&"
export * from "./AccordionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccordionPanel.vue?vue&type=style&index=0&id=48aa160c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aa160c",
  null
  
)

export default component.exports